// @ts-nocheck
import Levenshtein from 'levenshtein';

export const normalizePersonName = (value = '') => value
    .toLowerCase()
    .replace(/æ/g, 'ae')
    .replace(/ø/g, 'o')
    .replace(/å/g, 'aa')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

export const levenshteinDistance = (source = '', target = '') => new Levenshtein(source, target).distance;

const expandNameVariants = (value = '') => {
    const normalized = normalizePersonName(value);
    if (!normalized) return [];

    const tokens = normalized.split(' ').filter(Boolean);
    const variants = [normalized];

    if (tokens.length >= 2) {
        variants.push(`${tokens[0]} ${tokens[tokens.length - 1]}`);
    }
    if (tokens.length >= 3) {
        variants.push(tokens.slice(0, 2).join(' '));
        variants.push(tokens.slice(-2).join(' '));
    }

    return [...new Set(variants)];
};

export const getAdvisorNameCandidates = (advisor = {}) => {
    const fullName = `${advisor?.firstName || ''} ${advisor?.lastName || ''}`.trim();
    const emailLocalPart = advisor?.email?.split('@')[0]?.replace(/[._-]+/g, ' ');
    const values = [advisor?.name, fullName, advisor?.firstName, advisor?.lastName, emailLocalPart];
    return [...new Set(values.flatMap(expandNameVariants).filter(Boolean))];
};

export const getBookingAttendeeCandidates = (order = {}) => (
    (order?.bookings || [])
        .flatMap((booking) => booking?.vendorsAttendees || [])
        .flatMap(expandNameVariants)
        .filter(Boolean)
);

export const findBestAdvisorForBookings = (order, advisors = []) => {
    const attendees = getBookingAttendeeCandidates(order);
    if (!attendees.length || !advisors.length) return null;

    const advisorScores = advisors
        .map((advisor) => {
            let advisorBestScore = -1;

            const advisorCandidates = getAdvisorNameCandidates(advisor);
            if (!advisorCandidates.length) {
                return { advisor, score: advisorBestScore };
            }

            attendees.forEach((attendeeName) => {
                advisorCandidates.forEach((advisorName) => {
                    const maxLen = Math.max(attendeeName.length, advisorName.length);
                    if (!maxLen) return;

                    const distance = levenshteinDistance(attendeeName, advisorName);
                    const score = 1 - (distance / maxLen);
                    if (score > advisorBestScore) {
                        advisorBestScore = score;
                    }
                });
            });

            return { advisor, score: advisorBestScore };
        })
        .filter(({ score }) => score >= 0)
        .sort((a, b) => b.score - a.score);

    if (!advisorScores.length) return null;

    const bestMatch = advisorScores[0]?.advisor;
    const bestScore = advisorScores[0]?.score ?? -1;
    const secondBestScore = advisorScores[1]?.score ?? -1;

    const minimumSimilarity = 0.72;
    const minimumScoreGap = 0.08;
    const hasClearBestMatch = secondBestScore < 0 || (bestScore - secondBestScore) >= minimumScoreGap;

    if (!bestMatch || bestScore < minimumSimilarity || !hasClearBestMatch) return null;
    return bestMatch;
};
